export function avatarGradient(name, angleOverride) {
  if (!name) return 'hsl(220,80%,55%)'
  const parts = name.trim().split(/\s+/)
  const first = parts[0].toUpperCase()
  const i1 = (first.charCodeAt(0) || 65) - 65
  const i2 = (first.charCodeAt(1) || 65) - 65
  const hue1 = Math.round((i1 * 26 + i2) / 676 * 360)
  if (parts.length === 1) return `hsl(${hue1},80%,55%)`
  const last = parts[parts.length - 1].toUpperCase()
  const j1 = (last.charCodeAt(0) || 65) - 65
  const j2 = (last.charCodeAt(1) || 65) - 65
  const u = (j1 * 26 + j2) / 676
  const s = u * 2 - 1
  const offset = Math.round(Math.sign(s) * Math.pow(Math.abs(s), 0.5) * 90)
  const hue2 = (hue1 + offset + 360) % 360
  const consonants = name.toUpperCase().replace(/[^A-Z]/g, '').split('').filter(c => !'AEIOU'.includes(c))
  const a1 = consonants.length > 0 ? consonants[consonants.length - 1].charCodeAt(0) - 65 : 0
  const a2 = consonants.length > 1 ? consonants[consonants.length - 2].charCodeAt(0) - 65 : 0
  const angle = angleOverride ?? `${Math.round((a1 * 26 + a2) / 676 * 180)}deg`
  return `linear-gradient(${angle}, hsl(${hue1},80%,55%), hsl(${hue2},80%,45%))`
}

export function initials(name) {
  if (!name) return ''
  const parts = name.trim().split(/\s+/)
  return parts.length === 1 ? parts[0][0].toUpperCase() : (parts[0][0] + parts[parts.length - 1][0]).toUpperCase()
}
